
<!--<div class="pagebrkavoid"></div>-->
  

  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card">
        <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-0px padding-bottom-0px">
          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Sperm Source Details</label>
              <qrcode class="padding-top-0px padding-bottom-0px qr-style7" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>
            </div>
          </div>
          <div class="row bordertop border-bot-1px margin-left-0px margin-right-0px">
            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family">Patient:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-weight-bold font-family float-left">{{Owner}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family">Gender/Age:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left">{{Gender}}/{{Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family">Patient ID:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left">{{PatientId}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family">Infertility Type:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left">{{Infertility}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family">Cycle:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left">{{CycleType}} ({{CycleNo}})</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family">Protocol:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left">{{Protocol}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family">Protocol Start:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family">Protocol End:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-familysubhead font-weight-bold">Source Details:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left"></label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Source of Sperm:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{MaleSource}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Husband/Donor:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{SourceFrom}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Collection Date:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{DSADOC}} {{DSASTIMULATION}} {{DSAANTAG}} ({{ExtDate | date:'dd-MMM-yyyy'}})</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Collection Time:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{ExtTime | date:'hh:mm:ss'}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Storage Location:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{StorageLoc}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Technique:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{Technique}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-familysubhead font-weight-bold">Analysis:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left"></label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Date of Sample Collection:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{DateofsampleCollection | date:'dd-MMM-yyyy'}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Time of Sample Collection</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{TimeofsampleCollection | date:'hh:mm:ss'}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Volume(ml):</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{Volume}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Count(mil/ml):</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{Count}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Motile Sperm Motility(%):</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{MotileSpermMotility}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Active Progressivemotility(%):</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{ActiveProgressivemotility}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Cellular Debris(mil/ml):</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{CellularDebris}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Method of Preparation:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{MethodofPreparation}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Incubation Time(In Min):</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{IncubationTime}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Motile Sperm Count(mil/ml):</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{MotileSpermCount}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Motility(%):</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{Motility}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Notes:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{Notes}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Slide Observed?:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{SlideObserved}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-familysubhead font-weight-bold">Storage:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left"></label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Storage Type:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{StorageType}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Volume:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{StorageVolume}}{{StorageVolumeunits}}</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family">Details:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left">{{StorageDetails}}</label>
            </div>
          </div>

          <!--<div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>-->
          <!--<div class="row margin-left-0px margin-right-0px">
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family">Surgeon</label>
            </div>
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family">Assistant Surgeon</label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-7">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center"></label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family"></label>
                </div>
              </div>
            </div>
            <div class="col-print-5">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6 border-bot-1px">
                  <label class="margin-bottom-0px font-family text-align-center"></label>
                </div>
                <div class="col-print-5">
                  <label class="margin-bottom-0px font-family"></label>
                </div>
              </div>
            </div>
          </div>-->

        </div>
      </div>
    </div>
  </div>

  

<!--<printfooterview></printfooterview>-->












